import { render } from "./HelloWorld.vue?vue&type=template&id=7764d139&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=7764d139&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/hph-sitecore-sites/hph-sitecore-sites/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7764d139"]])

export default __exports__